export default function accessControlsListe(opts){console.info("[accessControlsListe] stub",opts);return[];}
